<script>
    export let fill = '#FFF'
</script>

<style>
    svg {
        position: absolute;
        bottom: 62px;
        left: 6px;
        width: 410.98px;
        height: 29.06px;
    }
</style>

<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 410.98 29.06">
    <g id="Layer_2" data-name="Layer 2">
        <g id="Layer_1-2" data-name="Layer 1">
            <rect {fill} width="221.4" height="29.06" />
            <rect {fill} x="226.74" width="181" height="29.06" />
        </g>
    </g>
</svg>
